<template>
  <com-header title="我的订单">

    <div class="my_order">
      <header>
        <h1>{{detailObj.orderContractName}}</h1>
        <p>订单号：{{detailObj.orderBatchNo}}</p>
      </header>

      <ul class="user">
        <li>
          <span class="label">客户姓名：</span><span>{{detailObj.consignee}}</span>
        </li>
        <li v-if="detailObj.consigneeTel">
          <span class="label">联系电话：</span><span>{{ String(detailObj.consigneeTel) | phoneInter }}</span>
        </li>
        <li>
          <span class="label">收货地址：</span><span> {{ detailObj.deliveryProName }}{{ detailObj.deliveryCityName
              }}{{ detailObj.deliveryDisName }}{{detailObj.deliveryTownName}}{{ detailObj.deliveryAddr }}</span>
        </li>
        <li style="marginTop:0.1rem">
          <span class="label">下单时间：</span><span>{{detailObj.createTime}}</span>
        </li>
        <li>
          <span class="label">付款状态：</span><span>{{detailObj.payStatus | fliterPayStatus}}</span>
        </li>
        <li>
          <span class="label">期望送货时间：</span><span>{{detailObj.goodsWishSendTime}}</span>
        </li>
      </ul>

      <div class="goods_box">
        <div class="total_num">
          共计<span class="fw_bold">{{totalCount}}</span>件商品
          <span v-if="detailObj.goodsMixTotalFee != undefined && showData.showGoodsSaleFee">
            ，合计金额<span class="fw_bold">￥{{detailObj.goodsMixTotalFee | priceValue}}</span>
          </span>
        </div>
        <div class="first_list" v-for="(item,index) in groupList" :key="index">
          <div class="first_name">{{item.groupName}}</div>
          <div class="second_list" v-for="(v, i) in item.goodsMixList" :key="i">
            <div class="goods">
              <div class="img"><img v-lazy="v.mainPreviewImageFilePath" /></div>
              <div class="itr">
                <p>{{v.goodsMixName+'（'+v.goodsMixNo+'）'}}</p>
                <p>{{v.attrName}}</p>
                <p class="price fw_bold" v-if="showData.showGoodsSaleFee">￥{{v.salePrice | priceValue}}</p>
              </div>
              <div class="count">x {{v.buyCount}}</div>
            </div>
            <div class="remark">备注：{{v.remark}}</div>
          </div>
        </div>
      </div>

      <div class="total_box">
        <div class="item" v-if="detailObj.goodsMixTotalFee != undefined && showData.showGoodsSaleFee">
          <span>商品总金额</span><span>￥{{detailObj.goodsMixTotalFee | priceValue}}</span>
        </div>
        <div class="item" v-if="detailObj.totalServiceFee != undefined && showData.showServiceFee">
          <span>服务费</span><span>+ ￥{{detailObj.totalServiceFee | priceValue}}</span>
        </div>
        <div class="item" v-if="detailObj.orderDisCountTotalFee != undefined && showData.showDiscountFee">
          <span>优惠</span><span>- ￥{{detailObj.orderDisCountTotalFee | priceValue}}</span>
        </div>
        <div class="item" v-if="detailObj.payFeeRev != undefined && showData.showActualFee">
          <span>实收金额</span><span>- ￥{{detailObj.payFeeRev | priceValue}}</span>
        </div>
        <div class="total_price fw_bold" v-if="detailObj.orderTotalFee != undefined && showData.showSaleTotalFee">
          <span>订单总金额：</span><span class="price">￥{{detailObj.orderTotalFee | priceValue}}</span>
        </div>
      </div>

      <div class="tips">
        <p class="fw_bold">交付期说明：</p>
        <p>1、对以下原因造成交付日期延误，经甲方确认，交付期相应顺延：</p>
        <p>（1）工作量变化或设计变更；</p>
        <p>（2）不可抗力因素；</p>
        <p>（3）甲方同意工期顺延的其他情况。</p>
        <p>2、甲方未按约定支付项目款，乙方有权停止交付，合同交付期相应顺延。</p>
        <p>3、因乙方责任不能按期交付，交付期不顺延，因乙方原因造成质量问题的，返工费由乙方承担，交付期不顺延。</p>
        <p>4、若有项目增减或需要变动，导致工程延期的，合同工期应顺延。</p>
      </div>

      <div class="sign_box" v-if="signValue && showData.showSign">
        <span class="fw_bold">签字：</span>
        <div class="img_box">
          <img class="img" :src="signValue" alt="">
        </div>
        <div class="icon" @click="openSign">
          <i class="el-icon-edit"></i>
        </div>
      </div>

      <footer v-if="detailObj.orderStatus == 1 && showData.showSign">
        <van-button type="danger" v-if="!signValue" @click="openSign">签字</van-button>
        <van-button type="danger" v-if="signValue" @click="openReserved">预留手机变更</van-button>
      </footer>
    </div>
    <!-- 客户签字 -->
    <signature-board ref="signRef" @confirm="getImage" :useMobile="true" />
    <!-- 预留手机 -->
    <reserved-phone ref="reservedRef" />
  </com-header>
</template>

<script>
import {
  GetOrderDetail_H5,
  SaveCustomerSignImg_H5,
} from "@/pages/page1/api-work/index";
import ComHeader from "./components/comHeader";
import SignatureBoard from "vue-signatureboard";
import ReservedPhone from "./components/reservedPhone.vue";
import { Button, Toast } from "vant";
export default {
  metaInfo: { title: "我的订单" },
  components: {
    ComHeader,
    SignatureBoard,
    ReservedPhone,
    [Button.name]: Button,
    [Toast.name]: Toast,
  },
  data() {
    return {
      signValue: "",
      detailObj: {},
      groupList: [],
      showData: {
        // 自定义权限控制
        showWay: 1,

        showGoodsSaleFee: 0, //商品销售价（销售单价，销售价小计，商品销售总金额）
        showServiceFee: 0, //服务费（包括运费、送装费、远程运输、搬运费、设计费等）
        showDiscountFee: 0, //订单优惠（优惠券抵扣、优惠减免）
        showSaleTotalFee: 0, //销售总金额
        showActualFee: 0, //实收金额（订单实际收款金额）

        showSign: 0, //客户签字
      },
      orderSign: "",
    };
  },
  mounted() {
    this.orderSign = this.$route.query.sign.replace(/\s/g, "+"); //全局替换空格
    this.getOrderDetail();
  },
  methods: {
    // 获取订单详情
    getOrderDetail() {
      let params = {
        orderSign: this.orderSign,
        showWay: this.$route.query.showWay,
      };
      GetOrderDetail_H5(params).then((res) => {
        // console.log("h5订单详情", res);
        this.detailObj = res.data[0];
        this.signValue = res.data[0].customerSignImg
          ? "data:image/png;base64," + res.data[0].customerSignImg
          : null;
        // 直接展示商品
        if (this.$route.query.showWay == 4) {
          this.groupList = [{ goodsMixList: this.detailObj.goodsMixList }];
        } else {
          this.groupList = this.detailObj.groupList;
        }
        this.groupList.forEach((v) => {
          v.goodsMixList.forEach((count) => {
            this.$set(count, "attrName", "");
            if (count.attr1ContentName) {
              count.attrName += count.attr1ContentName;
            }
            if (count.attr2ContentName) {
              count.attrName += "," + count.attr2ContentName;
            }
            if (count.attr3ContentName) {
              count.attrName += "," + count.attr3ContentName;
            }
            if (count.attr4ContentName) {
              count.attrName += "," + count.attr4ContentName;
            }
          });
        });

        this.actionShowData();
      });
    },
    actionShowData() {
      let arr = this.detailObj.orderContractPrintSet.split("#");
      // console.log(arr);
      let obj = {};
      arr.forEach((v) => {
        let arrItem = v.split("_");
        obj[arrItem[0]] = arrItem[1];
      });
      // console.log(obj);
      this.showData = obj;
    },
    // 打开签名
    openSign() {
      this.$refs.signRef.show(); //展示画板
      // this.$refs.signRef.canvasClear(); //清除画板
      // this.$refs.signRef.downloadSignImg(); //下载画板
    },
    // 上传签名 绑定参数B（后台处理） 更新订单详情
    getImage(pngbase64Img) {
      // console.log(pngbase64Img);
      let params = {
        orderSign: this.orderSign,
        customerSignImg: pngbase64Img,
      };
      Toast.loading({
        forbidClick: true,
        duration: 0,
      });
      SaveCustomerSignImg_H5(params).then((res) => {
        // console.log("上传签名", res)
        Toast.clear();
        this.openReserved();
        this.getOrderDetail();
      });
    },
    // 打开预留手机
    openReserved() {
      this.$refs.reservedRef.show(this.orderSign, this.detailObj.consignee);
    },
  },
  computed: {
    totalCount() {
      let res = 0;
      this.groupList.forEach((v) => {
        v.goodsMixList.forEach((count) => {
          res += count.buyCount;
        });
      });
      return res;
    },
  },
  filters: {
    fliterPayStatus(val) {
      let map = {
        1: "待付款",
        2: "部分付款",
        3: "已付全款",
        4: "部分退款",
        5: "已退全款",
      };
      return map[val];
    },
  },
};
</script>

<style lang="less" scoped>
.my_order {
  padding-bottom: 1.6rem;
  font-size: 14px;
  color: #333333;
  header {
    background: rgb(253, 234, 210);
    width: 100%;
    height: 1.6rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    h1 {
      font-size: 18px;
    }
    p {
      margin-top: 0.2rem;
      font-size: 14px;
    }
  }
  .user {
    padding: 0.2rem 0.3rem;
    line-height: 24px;
    .label {
      font-weight: bold;
    }
  }
  .goods_box {
    padding-bottom: 0.5rem;
    .total_num {
      padding: 0 0.3rem;
      line-height: 24px;
      border-bottom: 1px solid rgb(215, 215, 215);
    }
    .first_list {
      padding: 0.1rem 0.3rem;
      .first_name {
        line-height: 24px;
      }
      .second_list {
        margin-bottom: 0.3rem;
        padding-bottom: 0.1rem;
        border-bottom: 1px dashed rgb(215, 215, 215);
        &:last-child {
          margin-bottom: 0;
        }
        .goods {
          display: flex;
          .img {
            width: 1.4rem;
            height: 1.4rem;
            border: 1px solid rgba(168, 168, 168, 0.4);
            box-sizing: border-box;
          }
          .itr {
            width: calc(100% - 1.4rem - 0.8rem);
            padding-left: 0.4rem;
            box-sizing: border-box;
            font-size: 12px;
            line-height: 16px;
            p {
              margin-top: 0.1rem;
            }
          }
          .count {
            width: 0.8rem;
            align-self: flex-end;
          }
        }
        .remark {
          margin-top: 0.3rem;
          font-size: 12px;
          color: rgb(170, 170, 170);
        }
      }
    }
  }
  .total_box {
    border-top: 1px solid rgb(215, 215, 215);
    padding: 0.3rem;
    line-height: 24px;
    .item {
      display: flex;
      justify-content: space-between;
    }
    .total_price {
      text-align: right;
    }
  }
  .tips {
    border-top: 1px solid rgb(215, 215, 215);
    padding: 0.3rem 0.1rem;
    line-height: 24px;
  }
  .sign_box {
    border-top: 1px solid rgb(215, 215, 215);
    padding: 0.3rem;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .img_box {
      width: 2rem;
      height: 1rem;
      text-align: center;
      .img {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
      }
    }
    .icon {
      font-size: 24px;
    }
  }
  footer {
    padding: 0.3rem;
    text-align: right;
    .van-button {
      height: 30px;
      border-radius: 7px;
      padding: 0 20px;
      margin-right: 0.5rem;
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
.fw_bold {
  font-weight: bold;
}
.price {
  color: #ff0000;
}
</style>